import React from 'react';
import PropTypes from 'prop-types';
import styles from './TextBlock.module.scss';

const TextBlock = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default TextBlock;

TextBlock.propTypes = {
  children: PropTypes.node,
};

TextBlock.defaultProps = {
  children: null,
};
